const IMAGE_MIME_TYPE = 'image/png';
const REVOKE_OBJECT_URL_DELAY_MS = 1000;

export function base64ToBlob(base64: string, type = IMAGE_MIME_TYPE): Blob {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type });
}

export function createGeneratedImageFile(base64: string): File {
    return new File([base64ToBlob(base64)], `mein-raum-${Date.now()}.png`, { type: IMAGE_MIME_TYPE });
}

export function isFileSharingSupported(): boolean {
    return typeof navigator.share === 'function' && typeof navigator.canShare === 'function';
}

export function saveImageFile(file: File): void {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;
    link.click();

    /*                                                                       */
    window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_OBJECT_URL_DELAY_MS);
}

export async function shareImageFile(file: File, title: string): Promise<void> {
    if (!isFileSharingSupported() || !navigator.canShare({ files: [file] })) {
        return;
    }

    await navigator.share({ files: [file], title });
}
